export default {
  home: {
    metaTitle: "USFans Spreadsheet – Guía de creadores, reseñas y recursos",
    metaDescription: "Explora la hoja de cálculo de USFans con recursos de creadores, reseñas, información de envío, cupones, guías de seguridad, comparativas y consejos prácticos.",
    hero: {
      badge: "Recurso independiente · Actualizado con regularidad",
      title: "USFans Spreadsheet — Tu centro completo de recursos de USFans",
      subtitle: "Encuentra mejor información con la hoja de cálculo de USFans. Explora recursos, información de creadores, reseñas, guías de envío, cupones, información del almacén, consejos de seguridad y tutoriales prácticos — todo organizado en un solo lugar fácil de usar.",
      primaryCta: "Explorar la hoja de USFans",
      secondaryCta: "Comprar ahora",
      trust: "Recurso independiente · Guías fáciles de navegar · Actualizado con regularidad",
    },
    what: {
      title: "¿Qué es la hoja de cálculo de USFans?",
      p1: "La hoja de cálculo de USFans es un recurso estructurado diseñado para que la información relacionada con USFans sea más fácil de descubrir, comparar y comprender. En lugar de buscar entre páginas dispersas, puedes explorar guías organizadas, recursos de creadores, detalles de envío, reseñas y recomendaciones de seguridad en un solo lugar.",
      p2: "Como la hoja agrupa la información por categorías, te ayuda a pasar rápidamente de una búsqueda general a un producto o creador específico, sin saltar entre decenas de páginas sin relación.",
      cta: "Explorar el centro de la hoja",
    },
    features: {
      title: "Todo lo que necesitas saber sobre USFans",
      subtitle: "Un resumen rápido de los temas más útiles en torno a la hoja de cálculo de USFans.",
      spreadsheet: { title: "Hoja de cálculo de USFans", desc: "Explora el recurso central de la hoja y la información relacionada." },
      review: { title: "Reseña de USFans", desc: "Comprende las funciones clave, ventajas, limitaciones y consideraciones de los usuarios." },
      shipping: { title: "Coste de envío de USFans", desc: "Descubre qué afecta a los precios de envío y cómo comparar opciones." },
      coupon: { title: "Cupón de USFans", desc: "Encuentra información sobre promociones disponibles y cómo funcionan los cupones." },
      discount: { title: "Código de descuento de USFans", desc: "Aprende a verificar la información de descuentos antes de usar un código." },
      warehouse: { title: "Almacén de USFans", desc: "Comprende el almacén, el almacenamiento y el cumplimiento de pedidos." },
      legit: { title: "¿Es legítimo USFans?", desc: "Aprende a evaluar la legitimidad, la confianza y la seguridad." },
      safety: { title: "Seguridad de USFans", desc: "Sigue recomendaciones prácticas de privacidad, cuenta y navegación segura." },
    },
    popular: {
      title: "Empieza con la guía completa",
      subtitle: "Nuestra guía detallada explica qué es la hoja de cálculo de USFans, por qué importa y cómo usarla.",
      cta: "Leer la guía completa",
    },
    faqSection: {
      title: "Preguntas frecuentes",
      items: [
        { q: "¿Qué es la hoja de cálculo de USFans?", a: "Es un recurso estructurado que organiza la información de USFans — creadores, categorías, envío y más — en un centro fácil de explorar." },
        { q: "¿Es gratis explorar la hoja de cálculo de USFans?", a: "Explorar las guías y categorías es gratis. Las compras se realizan en la tienda principal." },
        { q: "¿Cómo encuentro un producto específico?", a: "Usa la lista de categorías de esta página para ir directamente a la sección correspondiente de la tienda principal." },
        { q: "¿Es legítimo USFans?", a: "Verifica siempre la información a través de fuentes oficiales y revisa las políticas de la tienda antes de comprar." },
      ],
    },
    finalCta: {
      title: "¿Listo para explorar toda la tienda?",
      subtitle: "Ve directamente al sitio principal para explorar todas las categorías y productos.",
      primary: "Visitar el sitio principal",
      secondary: "Comprar ahora",
    },
  },
};